const URL = '/debitos';

const state = {
  selected: {
    id: null,
    cuenta_id: null,
    precio_id: null,
    periodo: null,//no es necesario
    glosa: null,
    fecha: null,
    cantidad: 0,
    importe: 0,
    producto_id: 1,
    chofer_id: null,
  },
  edited: {
    id: null,
    cuenta_id: null,
    precio_id: null,
    periodo: null,//no es necesario
    glosa: null,
    fecha: null,
    cantidad: 0,
    importe: 0,
    producto_id: 1,
    chofer_id: null,
  },
  loading: false,
  rules: {
    cuenta_id: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe existir una cuenta asociada',
    ],
    precio_id: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe existir un precio asociado',
    ],
    periodo: [
      v => !!v || 'Este campo es necesario',
    ],
    fecha: [
      v => !!v || 'Este campo es necesario',
    ],
    cantidad: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe ser mayor a cero (0)',
    ],
    importe: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe ser mayor a cero (0)',
    ],
    glosa: [
      // v => !!v || 'Este campo es necesario',
    ],
    producto_id: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe existir un producto asociado',
    ],
  },
}

// GETTERS
const getters = {
  edited(state) {
    return state.edited
  },
  selected(state) {
    return state.selected
  },
  rules(state) {
    return state.rules
  },
  loading(state) {
    return state.loading
  },
  updatable(state) {
    return state.edited.id == state.selected.id &&
      state.edited.cantidad > 0 &&
      state.edited.cuenta_id > 0 &&
      state.edited.precio_id > 0 &&
      state.edited.periodo &&
      state.edited.fecha && (
        state.edited.cuenta_id != state.selected.cuenta_id ||
        state.edited.precio_id != state.selected.precio_id ||
        state.edited.periodo != state.selected.periodo ||
        state.edited.fecha != state.selected.fecha ||
        state.edited.cantidad != state.selected.cantidad ||
        state.edited.importe != state.selected.importe ||
        state.edited.producto_id != state.selected.producto_id
      )
  },
}

// ACTIONS
const actions = {
  onClearEdited({ commit }) {
    commit('setEdited', {
      id: null,
      cuenta_id: null,
      precio_id: null,
      periodo: null,
      fecha: null,
      cantidad: 0,
      importe: 0,
      glosa: null,
      producto_id: 1,
      chofer_id: null,
    })
  },
  onClearSelected({ commit }) {
    commit('setSelected', {
      id: null,
      cuenta_id: null,
      precio_id: null,
      periodo: null,
      fecha: null,
      cantidad: 0,
      importe: 0,
      glosa: null,
      producto_id: 1,
      chofer_id: null,
    })
  },
  onSave({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.post(URL, state.edited)
        .then(response => {
          const aux = {
            id: response.data.data.id,
            cuenta_id: response.data.data.cuenta_id,
            precio_id: response.data.data.precio_id,
            periodo: response.data.data.periodo,
            fecha: response.data.data.fecha,
            cantidad: response.data.data.cantidad,
            importe: response.data.data.importe,
            glosa: response.data.data.glosa,
            producto_id: response.data.data.producto_id
          }
          commit('setSelected', aux)
          commit('ResponseHTTP/addSuccess', 'El debito fue registrado.', { root: true })
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error. No se registro el debito', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}

// MUTATIONS
const mutations = {
  setEdited(state, payload) {
    state.edited = Object.assign({}, payload)
  },
  setSelected(state, payload) {
    state.selected = Object.assign({}, payload)
  },
  setLoading(state, payload) {
    state.loading = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
